import { render, staticRenderFns } from "./GenderSelect.vue?vue&type=template&id=c0b1eb50&scoped=true&"
import script from "./GenderSelect.vue?vue&type=script&lang=js&"
export * from "./GenderSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b1eb50",
  null
  
)

export default component.exports